module.exports = __webpack_public_path__ + "img/img4.add034a6.jpg";